<!-- 车位使用数据 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "startDate": "20190910000000",
                "endDate": "20190910235959",
                "minuteInterval": 240
            },
            responseCode: {
                    "data": {
                        "recordList": [
                            {
                                "parkId": 3424,
                                "recordDate": 1568649600000,
                                "recordDateText": "2019-09-17",
                                "slotsNumber": 380,
                                "timeAnalysis": [
                                    "04:00",
                                    "08:00",
                                    "12:00",
                                    "16:00",
                                    "20:00",
                                    "00:00"
                                ],
                                "usedAnalysis": [
                                    0.8816,
                                    0.8816,
                                    0.8816,
                                    0.8816,
                                    0.8816,
                                    0.8816
                                ]
                            }
                        ]
                    },
                    "message": "业务成功",
                    "resultCode": 0,
                    "status": 1
                }
                ,infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取车位使用情况数据",
                t_url: this.commonUrls.test+"parkingPlaceUsed",
                p_url: this.commonUrls.prod+"parkingPlaceUsed",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'startDate', info2: '是', info3: 'String', info4: '时间段起始时间，yyyyMMddHHmmss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '时间段结束时间，yyyyMMddHHmmss' },
                        { info1: 'minuteInterval', info2: '是', info3: 'Integer', info4: '分钟间隔(支持10或240)' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表,记录每一条代表一天的数据' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkId', info2: '是', info3: 'String', info4: '车场uuid' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'recordDate', info2: '是', info3: 'long', info4: '统计日期' },
                        { info1: 'recordDateText', info2: '是', info3: 'String', info4: '统计日期,yyyy-MM-dd' },
                        { info1: 'slotsNumber', info2: '是', info3: 'Integer', info4: '车场车位总数' },
                        { info1: 'timeAnalysis', info2: '是', info3: 'String[]', info4: '时间点序列' },
                        { info1: 'usedAnalysis', info2: '是', info3: 'String[]', info4: '使用分析序列' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/dataAnalysis/parkingPlaceUsed.vue